<template>
  <div id="app">
    <Header  ></Header>
    <router-view/>
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
import {contactlatest} from "./api";

export default {
  name: 'App',
  data() {
    return{
      contactInfo:{}
    }
  },
  created() {
     sessionStorage.removeItem('contactinfo')
    // this.getContact()
  },
  methods:{
    getContact(){
       contactlatest().then(res => {
        this.contactInfo = res.data
        sessionStorage.setItem('contactinfo',JSON.stringify(this.contactInfo))
      }).catch(error => {
      })
    }
  }
}

</script>

<style>
#app{
  background-image: url("./assets/img/home/aback.png");
  background-size: 1200px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue